import { cardRef, defineGameCard, onResolve } from '../authoring/index.js';
import { plannedUnit } from './helpers.js';
import { ReinforcedMicrodroneCard, ScrapCard } from './tokens.js';
export const WeldingPulseCard = defineGameCard({
    id: 'welding_pulse',
    gameplay: {
        type: 'SPELL', cost: 2,
        planning: {
            target: 'unit', unitFilter: 'ally',
            validatePlan(state, playerId, plan) {
                const target = plan.targetInstanceId === undefined ? undefined : state.instances[plan.targetInstanceId];
                return target !== undefined
                    && (target.controllerId ?? target.ownerId) === playerId
                    && target.zone === 'board'
                    && target.cellId !== undefined
                    && target.defId === ScrapCard.id;
            },
        },
    },
    presentation: {
        name: 'Сварочный импульс',
        description: 'Превратите выбранный свой Хлам в Усиленного микродрона 4/4.',
        glyph: {
            colors: ['#10213A', '#4F514D', '#6D6C67', '#323535', '#9D775B'],
            rows: [
                '....................',
                '....................',
                '....................',
                '.......11111........',
                '...11.12333331.11...',
                '..1324333333331551..',
                '.122443334333342551.',
                '.122122322513221321.',
                '.124122322243224421.',
                '12241223441232241521',
                '12241422415124411221',
                '14211422242244411241',
                '.121.1444444441.121.',
                '..1...14444441...1..',
                '.....1411111141.....',
                '.....121...1421.....',
                '....1241....1221....',
                '..5551115555.11555..',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: [
        cardRef('reinforced_microdrone'),
        cardRef('scrap'),
    ],
    abilities: [
        onResolve((ctx) => {
            const targetId = plannedUnit(ctx);
            if (targetId !== undefined)
                ctx.ops.transformCard(targetId, ReinforcedMicrodroneCard.id);
        }),
    ],
    ui: {
        mechanics: ['scrap'],
        planning: {
            steps: { unit: { label: 'Выберите свой Хлам' } },
        },
    },
});
//# sourceMappingURL=welding-pulse.js.map